<template>
  <span :class="[`icon-${icon}${fill ? '-bold' : ''}`, text, 'inline-block']"></span>
</template>

<script lang="ts" setup>
const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  fill: {
    type: Boolean,
    default: false,
  },
  text: {
    type: String,
    default: 'text-2xl',
  }
});
</script>

<style lang="scss" scoped></style>
